import { useId } from "react";

const ErrorAlert = () => {
  const id = useId().replace(/:/g, "");
  const patternId = `errorAlertPattern${id}`;
  const imageId = `errorAlertImage${id}`;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
    >
      <rect width="20" height="20" fill={`url(#${patternId})`} />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="scale(0.01)" />
        </pattern>
        <image
          id={imageId}
          width="100"
          height="100"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEwUlEQVR4nO2da6hlYxjHfy4zQ0PGJbfIhJnci0KSXHNJbuPDCPmADjHlEhn5YCIll8glHxC+uDTllojMFLkUYtS4zLhEjmHMODEYxjb+eqe1wm6fPWefvdZ6nvW+779+n06t/TzPr0577fW8e0NOTk5OTk5OTk5Ozwg2DfT+a06jEYwIfi4Ysa4n6Qj2FPwuUME6wSzrupKN4Jn/yCh52rquJCM4roeMkhOt60sqgs0EH/YR8pFgc+s6k4ng8j4ySi6zrjOJCLYVrJqAkB8F21vXG30E90xARsnd1vVGHcG+gj8HENIRHGBdd7QRvDSAjJJXreuOMoLTJyGj5DTr+qOKYKpg2RBCPhdMs+4jmgiuHUJGyTXWfUQRwY6CnyoQskawi3U/rY/goQpklDxo3U+rIzhYsL5CIeFah1r31doIXqtQRsmbgk2se2tdBOfUIKNkrnV/rYpgS8FXNQr5RjDdus/WRLCgRhklN1r32YoIdhP82oCQtYI9rPt1H8ETDcgoedy6X9cRHCH4u0Eh4bWOsu7b827VOw3KKHk/73T1iOAiAxklF1r37yqCrQUrDIWsFGxjPQc3EdxmKEMFt1rPwUUEewn+cCBknWA2qUfwnAMZKniWlCM43oEEdXESKSZsFgqWDjm8UcF7XYwOec2lSW49CuZV8Gxjeo/rblXBzeU8Etw+XD3k0Dp9rj/sQ60xwQ6kEsF9Ffyv7/S5fhVPGe8lhQj2KzYKvQv5S3AgsUfwcgXDUgNCAouIOYKzKhqUGhISOIOItw+Xt1DIF1FuPQrmVzgkNSgkcB0xRbBTcWy5rULWRLX1KHik4gGpYSGBh4khgkNqGlCnz2vW8XrhmofR5oQNQcHrNQxHBkICb7V661FwXk2DkZGQwLm0ePvw6wiFjLZy61FwU41DkaGQwALaFMHugt8iFrJWMJO2RPBUzQORsZDAk7QhgiMb2j7sGAsJHE0Ltg/fbWgYHQdCPghfhIPzb3dTQkIkuBjH24ffJShkpcutR8EdDQ5BjoQEbsdTBHsbbB92HAnxtfUoeKHhAciZkMDzeIjgBIPm5VBI4ORmp1/P9mFMQj4WTGnWwv8bv9KocTkVEriiWQv/Nr1dBduHMQoZM9l6FDxg2LQcCwnc37SMg4rNPsum14fF6nFuUJs8yWu/9ShYbNywClb0OI5geVax+a1HwdkOmlVLmFO3jGmCzxw0qpbwpWCLOoXc4KBJtYzr65Kxcw3bhynwi2DXOoQ85qA59Xi2PdZF3c/yJ8OjVcs43MFbSXXxQ9ioH2fL/nsH9dWz9VhsH77hoCl1saxPzZ84qK+btyvZehRc4KAZRSAkcP6wMsIR428dNKJIhIz2+nRhECG3OGhCEQkJ3DxZGTO7fpLOG8v71P6pg/qq3XoULHRQvPrQKY7JjXQxv6Jj13WycFAZxzooWpFzzCA/SbfEQcGKnCUT2noUXOqgWCXCJRuTMaO4A7YuVIkQZj2jn5C7HBSpxLhzPBn7DPiTdBkqIbwj3L+XkBcdFKdEeaVbxqkOilLinFLKmOL8zlaJEB6NTw1CrnZQTIYNXEXx9UPWhWTYwOosBFesKo8TZCmYE547nbnRj1JycnJycnJycnIYPP8AgaZz0bF9Wg0AAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};

export default ErrorAlert;
